<!-- TODO: traduzioni -->
<div>
  @if (mediaSource.mediaSourceType === MediaSourceType.Image) {
    <div class="flex flex-column align-items-center">
      <img [src]="mediaSource.fullPath" class="preview">
    </div>
  } @else {
    <div class="media-asset generic-media-asset">
      <span class="pi pi-file"></span>
    </div>
  }

  <div class="flex flex-row justify-content-between mt-4">
    <div class="flex flex-column">
      <app-input type="text" [(model)]="mediaSource.name" label="Nome" [showLength]="false"
                 [autoFocusOn]="true"
                 [maxLength]="250"></app-input>
      <app-input type="text" [(model)]="mediaSource.alternativeText" label="Testo alternativo" [showLength]="false"
                 class="mt-2"
                 [maxLength]="250"></app-input>
    </div>
    <app-input type="textarea" [(model)]="mediaSource.description" label="Descrizione" [showLength]="false"
               [maxLength]="100"></app-input>
  </div>
  <hr>
  <div class="flex flex-row justify-content-between">
    <app-action-button type="cancel" (click)="cancelSelection()" label="Annulla"
                       [textButton]="true"></app-action-button>
    <div>
      <!-- download icon -->
      @if (mediaSource.deleted) {
        <app-action-button type="reload" [textButton]="true" (click)="restore()"></app-action-button>
      } @else {
        <app-action-button type="delete" [textButton]="true" (click)="delete()"></app-action-button>
      }
      <app-action-button type="download" [textButton]="true" (click)="download()"></app-action-button>
      <app-action-button type="confirm" (click)="confirmSelection()" label="Conferma"></app-action-button>
    </div>
  </div>
</div>
